import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadDailyLogEntiresSuccess(entries) {
  return { type: types.LOAD_DAILY_LOG_ENTRIES_SUCCESS, entries };
}

export function createDailyLogEntrySuccess(entry) {
  return { type: types.CREATE_DAILY_LOG_SUCCESS, entry };
}

export function updateDailyLogEntrySuccess(entry) {
  return { type: types.UPDATE_DAILY_LOG_ENTRY_SUCCESS, entry };
}

export function deleteDailyLogEntrySuccess(entry) {
  return { type: types.DELETE_DAILY_LOG_ENTRY_SUCCESS, entry };
}

export function loadEntriesByLogId(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'daily-log/' + id + '/daily-log-entries';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadDailyLogEntiresSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveDailyLogEntry(entry, logId) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'daily-log-entries';
    if (entry.id) {
      url = baseApi + 'daily-log-entries/' + entry.id;
      return axios
        .put(url, {
          ...entry,
        })
        .then((response) => {
          dispatch(updateDailyLogEntrySuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          dailyLogId: logId,
          entryTime: entry.entryTime,
          entryMessage: entry.entryMessage,
        })
        .then((response) => {
          dispatch(createDailyLogEntrySuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteDailyLogEntry(entry) {
  return function (dispatch) {
    let url = baseApi + 'daily-log-entries/' + entry.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteDailyLogEntrySuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/dailyLogEntryActions.js